import React, { useState } from "react";
import { Eye, EyeOff, AlertCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={cn("pr-9", props.className)} />
      <button
        type="button"
        onClick={() => setShow(v => !v)}
        aria-label={show ? "Şifrəni gizlət" : "Şifrəni göstər"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export const Field: React.FC<{ error?: string; children: React.ReactNode }> = ({ error, children }) => (
  <div>
    {children}
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

export const OrDivider: React.FC<{ label: string }> = ({ label }) => (
  <div className="relative my-1">
    <div className="absolute inset-0 flex items-center">
      <div className="w-full border-t border-gray-200 dark:border-gray-700" />
    </div>
    <div className="relative flex justify-center">
      <span className="bg-white dark:bg-gray-900 px-3 text-xs text-gray-400 dark:text-gray-500 font-medium">{label}</span>
    </div>
  </div>
);

export const ErrorBanner: React.FC<{ message: string }> = ({ message }) =>
  message ? (
    <div role="alert" className="flex items-start gap-2.5 bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 rounded-xl px-3 py-2.5 text-sm">
      <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{message}</span>
    </div>
  ) : null;

export const linkCls =
  "text-blue-500 hover:text-blue-700 font-medium transition-colors dark:text-indigo-300 dark:hover:text-indigo-200";
